import api from './base-api';
import { TrackUtmEventDto } from '@sportspredict/shared';

const utmEventsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		trackUtmEvent: builder.mutation<void, TrackUtmEventDto>({
			query: (body) => ({
				url: '/utm-events',
				method: 'POST',
				body,
			}),
			extraOptions: { skipAuth: true },
		}),
	}),
	overrideExisting: false,
});

export default utmEventsApi;

export const { useTrackUtmEventMutation } = utmEventsApi;
